var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 750",
    style: {
      enableBackground: "new 0 0 750 750"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OKX OKC black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: "100%",
    width: "100%",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.5,214.9H69.6c-2.2,0-4,1.8-4,4v171.9c0,2.2,1.8,4,4,4h171.9c2.2,0,4-1.8,4-4V218.9 C245.5,216.6,243.7,214.9,241.5,214.9z M185.5,330.8c0,2.2-1.8,4-4,4h-51.9c-2.2,0-4-1.8-4-4v-51.9c0-2.2,1.8-4,4-4h52 c2.2,0,4,1.8,4,4L185.5,330.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M601.3,274.9h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C605.3,276.6,603.5,274.9,601.3,274.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M541.3,214.9h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C545.3,216.6,543.5,214.9,541.3,214.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M661.3,214.9h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C665.3,216.6,663.5,214.9,661.3,214.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M541.3,334.8h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C545.3,336.6,543.5,334.8,541.3,334.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M661.3,334.8h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C665.3,336.6,663.5,334.8,661.3,334.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M451.3,214.9h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C455.3,216.6,453.5,214.9,451.3,214.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M451.3,334.8h-52c-2.2,0-4,1.8-4,4v52c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-52C455.3,336.6,453.5,334.8,451.3,334.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M395.4,278.8c0-1.1-0.4-2.1-1.2-2.8c-0.7-0.7-1.8-1.2-2.8-1.2h-56v-55.9c0-2.2-1.8-4-4-4h-52c-2.2,0-4,1.8-4,4v171.8 c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-55.9h56c1.1,0,2.1-0.4,2.8-1.2c0.8-0.7,1.2-1.8,1.2-2.8V278.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.1,491.9c0,25.4,16.7,43.3,40.3,43.3s40.2-17.9,40.2-43.3s-16.6-43.3-40.3-43.3S395.1,466.5,395.1,491.9z M456.1,491.9 c0,16.1-8.5,26.3-20.7,26.3s-20.6-10.2-20.6-26.3s8.4-26.3,20.6-26.3S456.1,475.7,456.1,491.9L456.1,491.9z M522.9,449.9h-19.6v84 h19.5v-22.7l9.4-10.9l22.6,33.6h22.7l-32.3-48.7l30.3-35.3h-22.7l-29.9,36.4L522.9,449.9z M611.2,491.9c0-16,8.3-26.3,20-26.3 c8.7,0,14.9,5.5,16.8,14.4l18.4-6.1c-5.1-15.3-17.1-25.3-35.1-25.3c-23,0-39.7,17.9-39.7,43.3s16.6,43.3,39.7,43.3 c18,0,30-10,35.1-25.3l-18.4-6.1c-2,8.9-8.2,14.4-16.8,14.4C619.4,518.2,611.1,507.9,611.2,491.9L611.2,491.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.6,494.9h300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.6ecc0351a3b6a6eba54187c039cf1310.svg";
export { ForwardRef as ReactComponent };